import { STATUSES } from "@/lib/constants";

export const StatusBadge = ({ status, testId }) => {
  const s = STATUSES[status] || { label: status, cls: "bg-gray-100 text-gray-700 border-gray-200" };
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${s.cls}`} data-testid={testId}>
      {s.label}
    </span>
  );
};
